<div class="dropdown" [class.disabled]="disabled">
  <div class="select" [class.disabled]="disabled" (click)="!disabled && toggleDropdown()">
    {{ selectedOption ? (selectedOption | toTitleCase) : placeholderProp }}
    <img class="arrow" src="{{ disabled ? '../../../assets/images/arrow-disabled.svg' : '../../../assets/images/arrow.svg' }}" alt="arrow" [class.open]="showOptions" />
  </div>

  <div class="options" *ngIf="showOptions && !disabled">
    <div class="search">
      <img class="search-icon" src="../../../assets/images/search.svg" alt="icon search" />
      <input type="text" placeholder="Buscar" (input)="filterOptions($event)" />
    </div>

    <div class="option" *ngFor="let option of filteredOptions" [class.selected]="option === selectedOption"
      (click)="selectOption(option)">
      {{ option | toTitleCase }}
    </div>

    <div class="no-options" *ngIf="filteredOptions.length === 0">
      No se encontraron resultados.
    </div>
  </div>
</div>